import * as constants from './constants';
import controller from './controller';

const mutateClient = (client) => {
  return {
    ...client,
    isBlocked: client.statusRefValueId === constants.CLIENT_STATUS_LOCKED,
  };
};

const dispatchFail = (dispatch, failType, error) => {
  dispatch({ type: failType, payload: { loading: false, error } });
  throw error;
};

export function resetError() {
  return dispatch => dispatch({
    type: constants.RESET_ERROR,
    payload: { error: null },
  });
}

export function findClientByPhone(phoneNumber) {
  return dispatch => {
    dispatch({
      type: constants.FIND_CLIENT,
      payload: { loading: true, item: constants.initialState.item, error: undefined },
    });

    return controller.findClientByPhone(phoneNumber).then(response => {
      if (response.errorData) {
        return dispatchFail(dispatch, constants.FIND_CLIENT_FAIL, response.errorData);
      }

      return dispatch({
        type: constants.FIND_CLIENT_SUCCESS,
        payload: { item: mutateClient(response.data), loading: false, error: undefined },
      });
    });
  };
}

export function getClientInfo(clientId) {
  return dispatch => {
    dispatch({
      type: constants.FETCH_CLIENT,
      payload: { loading: true, error: undefined },
    });

    return controller.getClient(clientId).then(response => {
      if (response.errorData) {
        return dispatchFail(dispatch, constants.FETCH_CLIENT_FAIL, response.errorData);
      }

      return dispatch({
        type: constants.FETCH_CLIENT_SUCCESS,
        payload: { item: mutateClient(response.data), loading: false, error: undefined },
      });
    });
  };
}

export function createClient(data) {
  return dispatch => {
    dispatch({
      type: constants.CREATE_CLIENT,
      payload: { loading: true, error: undefined },
    });

    return controller.createClient(data).then(response => {
      if (response.errorData) {
        return dispatchFail(dispatch, constants.CREATE_CLIENT_FAIL, response.errorData);
      }

      return dispatch({
        type: constants.CREATE_CLIENT_SUCCESS,
        payload: { item: mutateClient(response.data), loading: false, error: undefined },
      });
    });
  };
}

export function updateClient(data) {  
  return dispatch => {
    dispatch({
      type: constants.UPDATE_CLIENT,
      payload: { loading: true, error: undefined },
    });

    return controller.updateClient(data)
      .then(response => {
        if (response.errorData) {
          return dispatchFail(dispatch, constants.UPDATE_CLIENT_FAIL, response.errorData);
        }

        return dispatch({
          type: constants.UPDATE_CLIENT_SUCCESS,
          payload: { item: mutateClient(response.data), loading: false, error: undefined },
        });
      });
  };
}

export function deleteClient(officeClientId) {
  return dispatch => {
    dispatch({
      type: constants.DELETE_CLIENT,
      payload: { loading: true, error: undefined },
    });

    return controller.deleteClient(officeClientId)
      .then(response => {
        if (response.errorData) {
          return dispatchFail(dispatch, constants.DELETE_CLIENT_FAIL, response.errorData);
        }

        return dispatch({
          type: constants.DELETE_CLIENT_SUCCESS,
          payload: { loading: false, error: undefined },
        });
      });
  };
}

export function getClientInsuranceLosses(clientId) {
  return dispatch => controller.getClientInsuranceLosses(clientId).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_CLIENT_INSURANCE_LOSSES_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_CLIENT_INSURANCE_LOSSES_SUCCESS,
      payload: { insuranceLosses: response.data, loading: false, error: undefined },
    });
  });
}

export function getClientServiceCards(clientId) {
  return dispatch => controller.getClientServiceCards(clientId).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_CLIENT_SERVICE_CARDS_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_CLIENT_SERVICE_CARDS_SUCCESS,
      payload: { serviceCards: response.data, loading: false, error: undefined },
    });
  });
}

export function clearClientData() {
  return dispatch => dispatch({
    type: constants.FETCH_CLIENT_SUCCESS,
    payload: { item: {} },
  });
}
